import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Defers opening a Dialog/AlertDialog that's triggered from inside a
 * DropdownMenuItem's onClick. Opening it synchronously in the same tick the
 * dropdown starts closing makes Radix's dismissable-layer stack stomp on
 * document.body's pointer-events style (the dropdown's dismissable-layer
 * captures the dialog's about-to-be-restored value mid-close-animation),
 * leaving the page unclickable after the dialog later closes. Letting the
 * dropdown's own close finish first avoids the overlap.
 */
export function deferDialogOpen(open: () => void) {
  setTimeout(open, 0);
}
